import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import Loader from "components/Loader";
import css from "./style.scss";

const LoaderModal = ({ isOpen }) => {
  if (!isOpen) return null;

  return (
    <div className={css.overlay}>
      <Loader />
    </div>
  );
};

export default LoaderModal;